import { STEPS as progressGr16_202307Steps, STEP_FIELDS as progressGr16_202307StepFields, FIELD_LABELS as progressGr16_202307FieldLabels } from "../progress-gr1-6-2023-07/steps";
import { STEPS as progressGr78_202307Steps, STEP_FIELDS as progressGr78_202307StepFields, FIELD_LABELS as progressGr78_202307FieldLabels } from "../progress-gr7-8-2023-07/steps";
import { STEPS as provincialGr16_202309Steps, STEP_FIELDS as provincialGr16_202309StepFields, FIELD_LABELS as provincialGr16_202309FieldLabels } from "../provincial-gr1-6-2023-09/steps";
import { STEPS as provincialGr78_202309Steps, STEP_FIELDS as provincialGr78_202309StepFields, FIELD_LABELS as provincialGr78_202309FieldLabels } from "../provincial-gr7-8-2023-09/steps";
import { STEPS as provincialGr912_202202SemSteps, STEP_FIELDS as provincialGr912_202202SemStepFields, FIELD_LABELS as provincialGr912_202202SemFieldLabels } from "../provincial-gr9-12-2022-02-sem/steps";

// Converts steps.js exports into the { step, key, label }[] format used by Class.jsx.
const buildLabelArray = (steps, stepFields, fieldLabels) =>
  steps.flatMap((step) =>
    (stepFields[step.id] ?? []).map((key) => ({
      step: step.title,
      key,
      label: fieldLabels[key] ?? key,
    }))
  );

export const REPORT_FIELD_LABELS = {
  pgrc1to6_2023_07: buildLabelArray(progressGr16_202307Steps, progressGr16_202307StepFields, progressGr16_202307FieldLabels),
  pgrc7to8_2023_07: buildLabelArray(progressGr78_202307Steps, progressGr78_202307StepFields, progressGr78_202307FieldLabels),
  pvrc1to6_2023_09: buildLabelArray(provincialGr16_202309Steps, provincialGr16_202309StepFields, provincialGr16_202309FieldLabels),
  pvrc7to8_2023_09: buildLabelArray(provincialGr78_202309Steps, provincialGr78_202309StepFields, provincialGr78_202309FieldLabels),
  pvrc9to12_2022_02_sem: buildLabelArray(provincialGr912_202202SemSteps, provincialGr912_202202SemStepFields, provincialGr912_202202SemFieldLabels),
};
